<!--

### - - Example usage - - ###

import emitter from "../utils/emitter.js";

emitter.emit('showNotification', {title: "hello World", content: "This is the content" , type: "success", show: true, timeout: true});


-->

<template>
  <!-- NOTIFICATION -->
  <div
    aria-live="assertive"
    class="
      fixed
      inset-0
      flex
      items-end
      px-4
      py-6
      pointer-events-none
      sm:p-6 sm:items-start
      z-50
    "
  >
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <transition
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="show"
          class="
            max-w-sm
            w-full
            bg-gray-900
            rounded-lg
            pointer-events-auto
            ring-1 ring-black ring-opacity-5
            overflow-hidden
            shadow-customOuter
          "
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon
                  v-if="type == 'success'"
                  class="h-6 w-6 text-green"
                  aria-hidden="true"
                />
                <ExclamationIcon
                  v-if="type == 'error'"
                  class="h-6 w-6 text-red-600"
                  aria-hidden="true"
                />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-gray-100">
                  {{ title }}
                </p>
                <p class="mt-1 text-sm text-gray-500">{{ content }}</p>
              </div>
              <div class="ml-4 flex-shrink-0 flex">
                <button
                  type="button"
                  @click="closeNotification"
                  class="
                    bg-transparent
                    rounded-md
                    inline-flex
                    text-gray-400
                    hover:text-gray-500
                    focus:outline-none focus:ring-2
                  "
                >
                  <span class="sr-only">Close</span>
                  <XIcon class="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { CheckCircleIcon } from "@heroicons/vue/outline";
import { XIcon, ExclamationIcon } from "@heroicons/vue/outline";
import emitter from "../utils/emitter.js";

// ## Define consts ##

const title = ref("");
const content = ref("");
const type = ref("");
const timeout = ref(true);
const show = ref(false);

emitter.on("showNotification", (payload) => {
  (title.value = payload.title),
    (content.value = payload.content),
    (type.value = payload.type),
    (show.value = payload.show),
    (timeout.value = payload.timeout);

  if (timeout.value == true) {
    setTimeout(() => {
      show.value = false;
    }, 4000);
  } else {
    setTimeout(() => {
      show.value = false;
    }, 10000);
  }
});

const closeNotification = () => {
  show.value = false;
};

onMounted(() => {});
</script>

